import useFeatureFlags from '@/features/feature-flags/hooks/useFeatureFlags';
import useHandleNotificationClick from '@/features/push/hooks/useHandleNotificationClick';
import { NotificationPayload } from 'firebase/messaging';
import { useEffect } from 'react';

export default function usePushWebServiceWorkerListener() {
  const featureFlags = useFeatureFlags();
  const handleNotificationClick = useHandleNotificationClick();

  useEffect(() => {
    if (!featureFlags.push.enabled || window.ReactNativeWebView || !navigator.serviceWorker) return;

    function onMessage(event: MessageEvent) {
      const data = event.data;
      if (!data || data.type !== 'PUSH_NOTIFICATION_CLICKED') return;
      handleNotificationClick(
        data.notification as NotificationPayload,
        data.data as Record<string, unknown>
      );
    }

    // eslint-disable-next-line compat/compat
    navigator.serviceWorker.addEventListener('message', onMessage);
    // eslint-disable-next-line compat/compat
    void navigator.serviceWorker.ready.then((registration) => {
      registration.active?.postMessage({ type: 'PUSH_CLIENT_READY' });
    });
    // eslint-disable-next-line compat/compat
    return () => navigator.serviceWorker.removeEventListener('message', onMessage);
  }, [featureFlags.push.enabled, handleNotificationClick]);
}
